export default {
    iconContainer: {
      marginRight: "24px",
    },
    inverseIcon: {
      transform: "rotate(90deg)",
    },
};
